import { useContributionTheme } from 'hooks';

const useCohereTheme = () => {
  // TODO: implement this hook
  const theme = useContributionTheme();
  return theme;
};

export default useCohereTheme;
